import { GroupByMode, newTaskSuffix } from '@griply/types';
import { getHiddenLinkedItemLabels, getNewTaskPrefill } from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';

import { DeadlineHeader } from '../deadline-header';
import { TreeTaskCard } from '../tree-task-card';
import { useDeadlineDeadlineRenderData } from './deadline-deadline-render-context';

export const DeadlineDeadlineRenderItem: React.FC<RenderItemProps> = ({
  item,
  itemInstance,
  tree,
  isMultiSelectModifierPressed,
}) => {
  const { groupSettings, tasksMap, tasks, overdueTasks, today, denseFormat } =
    useDeadlineDeadlineRenderData();

  const type = item.type;

  if (type === TaskListItemTypes.Task) {
    const task = tasksMap[item.sourceId];
    if (!task) {
      return null;
    }
    const { hideGoal, hideLifeArea } = getHiddenLinkedItemLabels(
      task,
      groupSettings,
    );
    return (
      <TreeTaskCard
        task={task}
        tree={tree}
        item={itemInstance}
        tasks={tasks}
        isMultiSelectModifierPressed={isMultiSelectModifierPressed}
        displayDue={groupSettings.displayDue}
        hideGoal={hideGoal}
        hideLifeArea={hideLifeArea}
      />
    );
  }

  if (type === TaskListItemTypes.NewTask) {
    const groupSectionId = item.sourceId.replace(newTaskSuffix, '');
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.DeadlineDeadline,
      groupSectionId,
      groupSetting: groupSettings,
      today,
    });
    return (
      <NewTaskRow
        deadlineDeadline={prefill.deadlineDeadline}
        startTime={null}
        duration={null}
        goal={prefill.goalId}
        lifeArea={prefill.lifeAreaId}
        tags={prefill.tagIds}
      />
    );
  }

  if (type === TaskListItemTypes.Date) {
    return (
      <DeadlineHeader
        denseFormat={denseFormat}
        item={itemInstance}
        overdueTasks={overdueTasks}
      />
    );
  }

  return null;
};
